import React, {useState} from 'react';
import { leftArrow, rightArrow } from '../../../assets/images';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function PrevArrow(props) {
  const {className, onClick, index } = props;
  return (
    (index > 0) && <img className={`${className} ml-7 z-20`} style={{ height: 22, width: 22 }} onClick={onClick} src={leftArrow}/>
  );
}

function NextArrow(props) {
  const { className, onClick, index, totalSlides, slidesToShow } = props
  return (
  (index <= totalSlides - slidesToShow) && <img className={`${className} mr-7`} style={{ height: 22, width: 22 }} onClick={onClick} src={rightArrow}/>
  )
}

const CardSlider = ({ data, slidesToShow = 1, slidesToScroll = 1, classes = '' }) => {
  const [state, setState] = useState({ activeSlide: 0 })
  let settings = {
    arrows: true,
    infinite: false,
    accessibility: true,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    prevArrow: <PrevArrow index={state.activeSlide} />,
    nextArrow: <NextArrow index={state.activeSlide} totalSlides={data.length} slidesToShow={slidesToShow}/>,
    afterChange: current => setState({ activeSlide: current })
  }

  return (
    <div className={`${classes} flex flex-col justify-between`}>
      <Slider {...settings} >
        {data.map((item) => item)}
      </Slider>
    </div>
  );
};

export default CardSlider;